import { useEffect, useMemo, useState } from 'react';

const useMediaQuery = (query: string): boolean => {
  const mediaMatch = useMemo(() => window.matchMedia(query), [query]);
  const [matches, setMatches] = useState(mediaMatch.matches);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (mediaMatch?.addEventListener) {
      const handler = (e) => setMatches(e.matches);
      mediaMatch.addEventListener('change', handler);
      return () => mediaMatch.removeEventListener('change', handler);
    }
  }, [mediaMatch]);

  return matches;
};

export default useMediaQuery;
